import { Route, Routes } from "react-router-dom";
// import StudentInfoPage from "./StudentInfoPage";
import QuizResultPage from "../quiz/QuizResultPage";
import QuizForPage from "../quiz/QuizForPage";
import ReportPage from "../ReportPage";
import { useRecoilValue } from "recoil";
import { signItem } from "../../states/atoms/signState";
import withNavigation from "../../hoc/withNavigation";
import LectureFindPage from "../lecture/LectureFindPage";
import StudentDashboardPage from "./StudentDashboardPage";

const StudentPage = () => {
  const signInfo = useRecoilValue(signItem);
  const info = signInfo && "info" in signInfo && signInfo.info;
  const id = info ? info._id : null;
  const userId = info ? info.userId : null;

  return (
    <>
      <Routes>
        <Route
          index
          element={<StudentDashboardPage student_id={id} userId={userId} />}
        />
        <Route path="lecture" element={<LectureFindPage student_id={id} />} />
        <Route path="report" element={<ReportPage />} />
        <Route path="quiz/result" element={<QuizResultPage />} />
        <Route path="quiz/response/:qid" element={<QuizForPage />} />
      </Routes>
    </>
  );
};

export default withNavigation(StudentPage);
